let ctx = null;

function getCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

function beep(freq, start, dur, vol = 0.12) {
  try {
    const c = getCtx();
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = "sine";
    o.frequency.value = freq;
    const t = c.currentTime + start;
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(vol, t + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.connect(g).connect(c.destination);
    o.start(t);
    o.stop(t + dur + 0.05);
  } catch { /* audio non disponibile */ }
}

export const playMessageSound = () => {
  beep(880, 0, 0.15);
  beep(660, 0.13, 0.22);
};

export const playMentionSound = () => {
  beep(990, 0, 0.12);
  beep(990, 0.16, 0.12);
  beep(1320, 0.32, 0.28);
};
